























import { Component, Vue, Prop } from 'vue-property-decorator';
import Accordion from '../accordion';
import IDropdown from './types';

@Component({
  components: {
    Accordion,
  },
})
export default class Dropdown extends Vue implements IDropdown {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly description!: string;

  @Prop({ type: Boolean, default: false })
  readonly isOpened!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly alwaysOpen!: boolean;

  @Prop({ type: String, default: '' })
  readonly height!: string;

  @Prop({ type: Boolean, default: false })
  readonly externalControl!: boolean;

  public opened: boolean = this.alwaysOpen || this.isOpened;

  get noArrow(): boolean {
    return this.alwaysOpen || this.externalControl;
  }

  get dropdownOpened(): boolean {
    return this.externalControl ? this.isOpened : this.opened;
  }

  onClick(): void {
    if (!this.noArrow) {
      this.opened = !this.opened;
      this.$emit('toggle', this.opened);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/dropdown/Dropdown.vue